type apiStatusProps = {
  [key: number]: string;
};

export const API_STATUS: apiStatusProps = {
  404: 'There is no survey for provided link',
  500: 'Something went wrong. Please contact administrator',
};

export const API_ASSISTANT_STATUS: apiStatusProps = {
  404: 'There is no languages for provided country',
  500: 'Something went wrong. Please contact administrator',
};
